import { local } from './storage';
import {
  ApigeeAuthAdapter,
  FirebaseAuthAdapter,
  HybridAuthAdapter,
} from './AuthenticationServiceInvoicePortal/authAdapters';
import config from '../config';
import AuthService, { TokenStorage } from './AuthenticationServiceInvoicePortal';

const apigeeAdapter = new ApigeeAuthAdapter({
  baseUrl: config.apigee.auth.url,
  clientId: config.apigee.auth.clientId,
});

const firebaseAdapter = new FirebaseAuthAdapter();

const hybridAdapter = new HybridAuthAdapter(firebaseAdapter, apigeeAdapter);
const tokensStorage = new TokenStorage(local, 'invoice-portal-token');

export default new AuthService(hybridAdapter, tokensStorage);
